<script>
import form from '@/utils/form';

import BaseInput from '@/components/BaseInput.vue';

export default {
  name: 'CompanyFormPopupWrappable',
  components: { BaseInput },
  data() {
    return {
      id: null,
      fields: {
        name: form.createFieldObject('text', 'Название компании', '', { required: 'Укажите название компании' }),
      },
    };
  },
  mounted() {
    this.$refs.field.focus();
  },
  methods: {
    init(params) {
      this.id = params.id ?? null;
      this.fields.name.value = params.name ?? '';
    },
    save() {
      form.validate(this.fields);
      if (form.hasErrors(this.fields)) return;

      const values = form.getValues(this.fields);
      this.$emit('finish', values);
    },
    cancel() {
      this.$emit('finish', false);
    },
  },
};
</script>

<template lang="pug">
  form(@submit.prevent="save").team-form
    .title {{ id ? 'Редактирование' : 'Создание' }} компании
    BaseInput(v-model="fields.name.value" v-bind="fields.name" ref="field")
    .buttons
      Btn(@click="save") Сохранить
      Btn(@click="cancel") Отмена
</template>

<style scoped lang="scss">
.team-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.buttons {
  display: flex;
  gap: 20px;
}
</style>
